import { takeLatest } from "redux-saga/effects";
import { apis } from "../../config/APIs";
import { sagaFunctions } from "../../utils";
import {
  Block,
  Cards,
  CardsDetails,
  CorporateBudget,
  DownloadBulk,
  Replacement,
  Topup,
  Transactions,
  UploadBulk,
  TransferLogs,
  UserCards,
  AnalyticsCards,
  AnalyticsCardsAll,
  AnalyticsCardsExport,
  CardPolicies,
  CardPoliciesDelete,
  CardLimitSet,
  GetCardPolicies,
  GetCardLimit,
  QucikLogs,
  CardLimitEnable,
  CardTxnType,
  ShowCardPolicy,
  SetCardPolicy,
  SetPin,
  UpdateMobileNumber,
  SendOTP,
  ActivateCard,
  VerifyOTP,
  RemindCardActivation,
  BlockReasons,
  TopUp,
  CardsTransfer,
  Transfers,
  UserLogs,
} from "./cards";

function getCards(req) {
  return sagaFunctions(Cards, "get", apis.cards, req.payload, {
    skipSuccessMessage: true,
  })();
}
function getTransfers(req) {
  const type = req.payload.type;
  if (type === "bulk-internal" || type === "bulk") {
    delete req.payload.type;
  }
  return sagaFunctions(
    Transfers,
    "get",
    type === "bulk-internal"
      ? apis.transfersBlukShow
      : type === "bulk"
        ? apis.transfersBluk
        : apis.transfers,
    req.payload,
    { skipSuccessMessage: true },
  )();
}
function cardsPoliciesDelete(req) {
  return sagaFunctions(
    CardPoliciesDelete,
    "post",
    apis.cardPolicyDelete + "?card_policy_id=" + req.payload,
  )();
}

function getQuickLogs(req) {
  return sagaFunctions(QucikLogs, "get", apis.qucikLoad, req.payload, {
    skipSuccessMessage: true,
  })();
}

function getUserLogs(req) {
  return sagaFunctions(UserLogs, "get", apis.userLogs, req.payload, {
    skipSuccessMessage: true,
  })();
}

function getCardPoliciesNLimits() {
  return sagaFunctions(GetCardPolicies, "get", apis.cardPoliciesNLimits, null, {
    skipSuccessMessage: true,
  })();
}

function getCardLimits(req) {
  return sagaFunctions(GetCardLimit, "get", apis.cardLimit, req.payload, {
    skipSuccessMessage: true,
  })();
}

function getCardPolicies(req) {
  if (req?.payload?.type === "expense") {
    return sagaFunctions(
      CardPolicies,
      "get",
      apis.fetch_expense_policy_data,
      null,
    )();
  }
  return sagaFunctions(CardPolicies, "get", apis.cardPolicies, null)();
}

function setCardPolicies(req) {
  return sagaFunctions(CardLimitSet, "post", apis.cardLimitSet, req.payload, {
    "Content-Type": "application/json;charset=UTF-8",
  })();
}

function cardEnableLimit(req) {
  return sagaFunctions(
    CardLimitEnable,
    "post",
    apis.enableTxnType,
    req.payload,
    {
      "Content-Type": "application/json; charset=UTF-8",
    },
  )();
}

function cardTxnTypeLimit(req) {
  return sagaFunctions(CardTxnType, "post", apis.enableCardLimit, req.payload, {
    "Content-Type": "application/json; charset=UTF-8",
  })();
}

function downloadBulk(req) {
  return sagaFunctions(DownloadBulk, "get", apis.downloadBulk, req.payload, {
    skipSuccessMessage: true,
  })();
}

function getTransferlog(req) {
  return sagaFunctions(TransferLogs, "get", apis.tranferlog, req.payload, {
    skipSuccessMessage: true,
  })();
}

function setPin(req) {
  return sagaFunctions(SetPin, "post", apis.set_pin, req.payload)();
}

function verify_otp(req) {
  return sagaFunctions(VerifyOTP, "post", apis.verify_otp, req.payload)();
}

function activate_card(req) {
  const v1 = req.payload.v1;
  delete req.payload.v1;
  return sagaFunctions(
    ActivateCard,
    "post",
    v1 ? apis.activate_v1 : apis.activate,
    req.payload,
  )();
}

function sendOtp(req) {
  return sagaFunctions(SendOTP, "post", apis.send_otp, req.payload)();
}

function update_mobile_number(req) {
  return sagaFunctions(
    UpdateMobileNumber,
    "post",
    apis.update_mobile_number,
    req.payload,
    { skipErrorMessage: true },
  )();
}

function remind_card_activation(req) {
  return sagaFunctions(
    RemindCardActivation,
    "post",
    apis.remind_card_activation,
    req.payload,
  )();
}

function analyticsCards(req) {
  let type = req.payload.type;
  delete req.payload.type;
  if (type === "reports") {
    return sagaFunctions(
      AnalyticsCards,
      "get",
      apis.analytics_reports,
      req.payload,
      { skipSuccessMessage: true },
    )();
  } else if (type === "expenses") {
    return sagaFunctions(
      AnalyticsCards,
      "get",
      apis.analytics_expenses,
      req.payload,
      { skipSuccessMessage: true },
    )();
  } else if (type === "trips") {
    return sagaFunctions(
      AnalyticsCards,
      "get",
      apis.analytics_trips,
      req.payload,
      { skipSuccessMessage: true },
    )();
  } else if (type === "advances") {
    return sagaFunctions(
      AnalyticsCards,
      "get",
      apis.analytics_advances,
      req.payload,
      { skipSuccessMessage: true },
    )();
  }
  return sagaFunctions(
    AnalyticsCards,
    "get",
    apis.analytics_cards,
    req.payload,
  )();
}

function analyticsCardsAll(req) {
  let type = req.payload.type;
  delete req.payload.type;
  if (type === "reports") {
    return sagaFunctions(
      AnalyticsCardsAll,
      "get",
      apis.analytics_reports,
      req.payload,
      { skipSuccessMessage: true },
    )();
  } else if (type === "expenses") {
    return sagaFunctions(
      AnalyticsCardsAll,
      "get",
      apis.analytics_expenses,
      req.payload,
      { skipSuccessMessage: true },
    )();
  } else if (type === "trips") {
    return sagaFunctions(
      AnalyticsCardsAll,
      "get",
      apis.analytics_trips,
      req.payload,
      { skipSuccessMessage: true },
    )();
  } else if (type === "advances") {
    return sagaFunctions(
      AnalyticsCardsAll,
      "get",
      apis.analytics_advances,
      req.payload,
      { skipSuccessMessage: true },
    )();
  }
  return sagaFunctions(
    AnalyticsCardsAll,
    "get",
    apis.analytics_cards,
    req.payload,
  )();
}

function analyticsCardsExport(req) {
  let type = req.payload?.type;
  delete req.payload?.type;
  if (type === "reports") {
    return sagaFunctions(
      AnalyticsCardsExport,
      "get",
      apis.txn_report_export,
      req.payload,
      { skipSuccessMessage: true },
    )();
  } else if (type === "expenses") {
    return sagaFunctions(
      AnalyticsCardsExport,
      "get",
      apis.analytics_expenses_export,
      req.payload,
      { skipSuccessMessage: true },
    )();
  } else if (type === "trips") {
    return sagaFunctions(
      AnalyticsCardsExport,
      "get",
      apis.analytics_trips_export,
      req.payload,
      { skipSuccessMessage: true },
    )();
  } else if (type === "advances") {
    return sagaFunctions(
      AnalyticsCardsExport,
      "get",
      apis.analytics_advances_export,
      req.payload,
      { skipSuccessMessage: true },
    )();
  }
  return sagaFunctions(
    AnalyticsCardsExport,
    "get",
    apis.txn_card_export,
    req.payload,
  )();
}

function getUserCards(req) {
  return sagaFunctions(UserCards, "get", apis.userCards, req.payload, {
    skipSuccessMessage: true,
  })();
}

function block_reasons(req) {
  return sagaFunctions(BlockReasons, "post", apis.blockReasons, req.payload, {
    skipSuccessMessage: true,
  })();
}

function showCardPolicy(req) {
  return sagaFunctions(
    ShowCardPolicy,
    "get",
    apis.show_card_policy,
    req.payload,
  )();
}

function setCardPolicy(req) {
  return sagaFunctions(SetCardPolicy, "post", apis.setCardLimit, req.payload)();
}

function getCardsDetails(req) {
  return sagaFunctions(CardsDetails, "get", apis.cardsDetails, req.payload, {
    skipSuccessMessage: true,
  })();
}

function getTransactions(req) {
  return sagaFunctions(
    Transactions,
    "get",
    apis.cardTransactions,
    req.payload,
  )();
}

function getTopup(req) {
  return sagaFunctions(Topup, "post", apis.topup, req.payload, {
    "Content-Type": "multipart/formdata",
  })();
}

function uploadBulk(req) {
  return sagaFunctions(UploadBulk, "post", apis.uploadBulk, req.payload, {
    "Content-Type": "multipart/formdata",
  })();
}

function block_card(req) {
  return sagaFunctions(Block, "post", apis.block, req.payload)();
}

function replacement(req) {
  return sagaFunctions(Replacement, "post", apis.replacement, req.payload)();
}

function corporate_budget() {
  return sagaFunctions(CorporateBudget, "post", apis.corporate_budget, null, {
    skipSuccessMessage: true,
    skipErrorMessage: true,
  })();
}

function topUp(req) {
  return sagaFunctions(TopUp, "post", apis.payment_gateway, req.payload)();
}

function cardsTransferAPI(req) {
  const { payload } = req;
  const { card_id, amount, transfer_from, transfer_to } = payload;

  // Construct query string
  const queryString = `card_id=${card_id}&amount=${amount}&source=${transfer_from}`;
  const isTransit = transfer_to?.toLowerCase() === "transit";

  // Handle payload modification
  if (isTransit) {
    delete req.payload;
  } else {
    payload.beneficiary_id = transfer_to;
    delete payload.transfer_to;
  }

  // Determine API endpoint
  const apiEndpoint = isTransit
    ? `${apis.cardsTransferAPI}?${queryString}`
    : apis.fundTransferAPI;

  // Make API call
  return sagaFunctions(CardsTransfer, "post", apiEndpoint, req.payload || {})();
}

export function* cardsWatcher() {
  yield takeLatest(Cards.REQUEST, getCards);
  yield takeLatest(Transfers.REQUEST, getTransfers);
  yield takeLatest(TopUp.REQUEST, topUp);
  yield takeLatest(SendOTP.REQUEST, sendOtp);
  yield takeLatest(VerifyOTP.REQUEST, verify_otp);
  yield takeLatest(UpdateMobileNumber.REQUEST, update_mobile_number);
  yield takeLatest(ActivateCard.REQUEST, activate_card);
  yield takeLatest(ShowCardPolicy.REQUEST, showCardPolicy);
  yield takeLatest(SetCardPolicy.REQUEST, setCardPolicy);
  yield takeLatest(CardPoliciesDelete.REQUEST, cardsPoliciesDelete);
  yield takeLatest(CardLimitEnable.REQUEST, cardEnableLimit);
  yield takeLatest(CardTxnType.REQUEST, cardTxnTypeLimit);
  yield takeLatest(QucikLogs.REQUEST, getQuickLogs);
  yield takeLatest(UserLogs.REQUEST, getUserLogs);
  yield takeLatest(GetCardLimit.REQUEST, getCardLimits);
  yield takeLatest(GetCardPolicies.REQUEST, getCardPoliciesNLimits);
  yield takeLatest(CardPolicies.REQUEST, getCardPolicies);
  yield takeLatest(CardLimitSet.REQUEST, setCardPolicies);
  yield takeLatest(UserCards.REQUEST, getUserCards);
  yield takeLatest(CardsDetails.REQUEST, getCardsDetails);
  yield takeLatest(Transactions.REQUEST, getTransactions);
  yield takeLatest(Topup.REQUEST, getTopup);
  yield takeLatest(Block.REQUEST, block_card);
  yield takeLatest(DownloadBulk.REQUEST, downloadBulk);
  yield takeLatest(UploadBulk.REQUEST, uploadBulk);
  yield takeLatest(CorporateBudget.REQUEST, corporate_budget);
  yield takeLatest(Replacement.REQUEST, replacement);
  yield takeLatest(TransferLogs.REQUEST, getTransferlog);
  yield takeLatest(AnalyticsCards.REQUEST, analyticsCards);
  yield takeLatest(AnalyticsCardsAll.REQUEST, analyticsCardsAll);
  yield takeLatest(AnalyticsCardsExport.REQUEST, analyticsCardsExport);
  yield takeLatest(SetPin.REQUEST, setPin);
  yield takeLatest(RemindCardActivation.REQUEST, remind_card_activation);
  yield takeLatest(BlockReasons.REQUEST, block_reasons);
  yield takeLatest(CardsTransfer.REQUEST, cardsTransferAPI);
}
